import { get, post, put, del } from "@/api/common/request";

// /interview/list
// 入参：current_status、interview_param、page_num、page_size
export const listInterview = (params) => get("/interview/list", params);

// /interview/create
// 入参：candidate_name、candidate_phone、candidate_email、position、resume、interview_time、interviewers_id、recruiters_id
export const createInterview = (params) => post("/interview", params);

// /interview/{interview_id}
// 入参：candidate_name、candidate_phone、candidate_email、position、resume、interview_time、interviewers_id、recruiters_id
export const updateInterview = (id, params) => put(`/interview/${id}`, params);

// /interview/{interview_id}
export const deleteInterview = (id) => del(`/interview/${id}`);

// /interview/send_notification — 发送面试通知
export const sendInterviewNotification = (params = {}) => post("/interview/send_notification", params);

// /interview/send_evaluation_sms — 发送评价提醒短信
export const sendInterviewEvaluationSms = (params = {}) => post("/interview/send_evaluation_sms", params);

// /evaluation
// 入参：interview_id、professional_ability、communication_skill、logical_thinking、stability、
// comprehensive_score（五维总分 0–100）、text_evaluation、evaluation_result
// 五维录入侧：projectMatchDegree(35)+presentationSkill(20)+responsibility(15)+teamwork(15)+jobStability(15)；
// 提交时 logical_thinking = responsibility+teamwork，其余一一对应。
export const submitEvaluation = (params) => post("/evaluation", params);

// /interview/review/list
// 入参：{}
export const listInterviewReview = (params = {}) => get("/interview/review/list", params);

// /interview/recording-remarks — 复核结论提交
// 入参：interview_id、review_conclusion（1/2/3）、review_remarks（最多 300 字）
export const submitRecordingRemarks = (params = {}) => post("/interview/recording-remarks", params);

// /interview/room/{room_id}/sig
// 入参：path 参数 room_id
export const getInterviewRoomSig = (roomId) => post(`/interview/room/${roomId}/sig`);

// /interview/room/sig
// 入参：userId 拼接在 URL 查询串中
export const getInterviewRoomSigByUserId = (userId) =>
  post(`/interview/room/sig?userId=${encodeURIComponent(String(userId || ""))}`, {});

// /interview/room/status
// 入参：id
// 返回：data.room_status（1：面试官已进入房间）
export const getInterviewRoomStatus = (id) => post(`/interview/room/status`, { id });

// /interview/room/enter
// 入参：id、room_status（1：固定为 1）
export const enterInterviewRoom = (id, roomStatus = 1) =>
  post(`/interview/room/enter`, { id, room_status: roomStatus });

// /interview/room/recording/start
// 入参：interview_id（面试 id）
export const startInterviewRoomRecording = (interviewId) =>
  post("/interview/room/recording/start", { interview_id: interviewId });

// /interview/room/recording/stop
// 入参：interview_id（面试 id）
export const stopInterviewRoomRecording = (interviewId) =>
  post("/interview/room/recording/stop", { interview_id: interviewId });

// /interview/room/{id}/interviewer-enter-time
// 入参：path 参数 id
export const getInterviewerEnterTime = (id) => get(`/interview/room/${id}/interviewer-enter-time`);

// /frame/list — 异常帧列表（复核页时间轴）
// 入参：{ interview_id: id }
export const getFrameList = (params = {}) => get("/frame/list", params);

// /frame/report — 异常行为 AI 检测意见（复核页）
// 入参：{ interview_id }
export const getFrameReport = (params = {}) => get("/frame/report", params);

// /common/file-link — 获取带签名的可访问地址（参数与后端约定一致，常用 fileName）
export const getCommonFileLink = (params) => get("/common/file-link", params);

// /interview/video-asset/{interview_id} — 获取面试录像资产信息（例如 file_name）
export const getInterviewVideoAsset = (interviewId) => get(`/interview/video-asset/${interviewId}`);

// /interview/{interview_id}/report/regenerate — 重新生成面试评估报告（PDF）
export const regenerateInterviewReport = (interviewId) =>
  post(`/interview/${interviewId}/report/regenerate`, {});

// /interview/{interview_id}/report/data — 获取面试评估报告 JSON 数据
export const getInterviewReportData = (interviewId) =>
  get(`/interview/${interviewId}//report/data`);

// /interview/{interview_id}/report/push-oa — 推送报告到 OA
export const pushReportToOa = (interviewId) =>
  post(`/interview/${interviewId}/report/push-oa`, {});

